import { createGlobalStyle } from "styled-components";


export const GlobalStyle = createGlobalStyle`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  ul,
  ol {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  button {
    padding: 0;
    border: none;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
  

html {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  margin: 0;
  font-family:'Roboto', sans-serif,  'Segoe UI', -apple-system, BlinkMacSystemFont,
    Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  color: #212121;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}


`;

/* html, body {
 overflow: ${($isopen) => ($isopen ? "hidden" : "visible")};

} */
// html, body {
// /* overflow: ${($isopen) => ($isopen ? "hidden" : "visible")}; */
// overflow: visible;
// }
//  body.noScroll {
//     overflow: hidden;
//   }

/* body {
  overflow: ${(open) => (open ? "hidden" : "visible")}
} */
/* html, body {
overflow: ${(isopen) => (isopen ? "hidden" : "scroll")};
} */
